export default __webpack_public_path__ + "static/media/retail1.08aa27e4.jpg";